interface ThumbsDownIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  /** When true, the thumb is filled (solid) instead of outline */
  filled?: boolean;
  /** Stroke/outline color; when not provided uses currentColor */
  color?: string;
}

export function ThumbsDownIcon({
  className,
  width = "16",
  height = "16",
  filled = false,
  color,
}: ThumbsDownIconProps) {
  const strokeColor = color ?? "currentColor";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      style={color ? { color } : undefined}
    >
      <g clipPath="url(#clip0_thumbs_down_icon)">
        <path
          d="M9.91602 8.16797V1.16797"
          stroke={strokeColor}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.24979 10.5713L5.83312 8.16797H2.43229C2.25117 8.16797 2.07254 8.1258 1.91054 8.0448C1.74854 7.9638 1.60763 7.8462 1.49896 7.7013C1.39029 7.55641 1.31684 7.3882 1.28444 7.21C1.25204 7.0318 1.26158 6.84851 1.31229 6.67463L2.67146 2.00797C2.74214 1.76563 2.88951 1.55276 3.09146 1.4013C3.2934 1.24984 3.53903 1.16797 3.79146 1.16797H11.6665C11.9759 1.16797 12.2726 1.29089 12.4914 1.50968C12.7102 1.72847 12.8331 2.02522 12.8331 2.33464V7.0013C12.8331 7.31072 12.7102 7.60747 12.4914 7.82626C12.2726 8.04505 11.9759 8.16797 11.6665 8.16797H10.0565C9.83941 8.16808 9.6267 8.22874 9.44223 8.34313C9.25777 8.45752 9.10888 8.62109 9.01229 8.81547L6.99979 12.8346C6.7247 12.8312 6.45394 12.7657 6.20774 12.643C5.96153 12.5202 5.74625 12.3434 5.57797 12.1258C5.40969 11.9081 5.29277 11.6553 5.23594 11.3861C5.17912 11.1169 5.18385 10.8384 5.24979 10.5713Z"
          fill={filled ? strokeColor : "none"}
          stroke={strokeColor}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_thumbs_down_icon">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
